//src/utils/offlineSync.js
import localforage from 'localforage';
import { v4 as uuidv4 } from 'uuid';

const OFFLINE_CHANGES_KEY = 'offline_changes';

// Save change when offline
export const saveOfflineChange = async (tableName, data, action = 'create') => {
  const changes = (await localforage.getItem(OFFLINE_CHANGES_KEY)) || [];
  const record = {
    ...data,
    uuid: data.uuid || uuidv4(),
    last_modified: new Date().toISOString(),
    sync_status: 'pending'
  };
  changes.push({
    table_name: tableName,
    record_uuid: record.uuid,
    data: record,
    action,
    status: 'pending',
    created_at: new Date().toISOString()
  });
  await localforage.setItem(OFFLINE_CHANGES_KEY, changes);
  return record.uuid;
};

// Get all pending changes
export const getPendingChanges = async () => {
  return (await localforage.getItem(OFFLINE_CHANGES_KEY)) || [];
};

// Clear synced changes
export const clearSyncedChanges = async (syncedUUIDs) => {
  const changes = await getPendingChanges();
  const filtered = changes.filter(c => !syncedUUIDs.includes(c.record_uuid));
  await localforage.setItem(OFFLINE_CHANGES_KEY, filtered);
};

// Auto-sync when online
export const syncOfflineChanges = async (apiUrl, token) => {
  const changes = await getPendingChanges();
  if (!changes.length) return;

  try {
    const res = await fetch(`${apiUrl}/offline-sync`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ changes })
    });

    if (res.ok) {
      const { syncedUUIDs } = await res.json();
      await clearSyncedChanges(syncedUUIDs);
      console.log('✅ Offline sync successful');
    } else {
      console.warn('⚠️ Sync failed, will retry later');
    }
  } catch (err) {
    console.error('❌ Sync error:', err);
  }
};